import * as actionsTypes from './actions';

const initialState = {
    isLoading: false,
    allSites: {},
    site: {},
    installationDateIsLoading: false,
    impulseRateHistory: {},
    firmwareHistory: {},
    deviceHistory: []
}

export default function (state = { ...initialState }, action) {
    switch (action.type) {

        case actionsTypes.GET_ALL_SITE_REQUEST:
            return { ...state, isLoading: true }

        case actionsTypes.GET_ALL_SITE_SUCCESS:
            return { ...state, isLoading: false, allSites: action.payload || {} }

        case actionsTypes.GET_ALL_SITE_FAILED:
            return { ...state, isLoading: false }

        case actionsTypes.ADD_SITE_REQUEST:
            return { ...state }

        case actionsTypes.ADD_SITE_SUCCESS:
            return { ...state }

        case actionsTypes.ADD_SITE_FAILED:
            return { ...state }


        case actionsTypes.GET_SINGLE_SITE_REQUEST:
            return { ...state, isLoading: true }

        case actionsTypes.GET_SINGLE_SITE_SUCCESS:
            return { ...state, isLoading: false, site: action?.payload || {} }

        case actionsTypes.GET_SINGLE_SITE_FAILED:
            return { ...state, isLoading: false }

        // end of site reducer 


        case actionsTypes.GET_DEVICE_BY_ID_REQUEST:
            return { ...state, isLoading: true }

        case actionsTypes.GET_DEVICE_BY_ID_SUCCESS:
            return { ...state, isLoading: false, device: action.payload || {} }

        case actionsTypes.GET_DEVICE_BY_ID_FAILED:
            return { ...state, isLoading: false }

        case actionsTypes.UPDATE_DEVICE_BY_ID_REQUEST:
            return { ...state, isLoading: true }

        case actionsTypes.UPDATE_DEVICE_BY_ID_SUCCESS:
            return { ...state, isLoading: false, }

        case actionsTypes.UPDATE_DEVICE_BY_ID_FAILED:
            return { ...state, isLoading: false }

        case actionsTypes.UPDATE_DEVICE_INSTALLATION_DATE_REQUEST:
            return { ...state, installationDateIsLoading: true }

        case actionsTypes.UPDATE_DEVICE_INSTALLATION_DATE_SUCCESS:
            return { ...state, installationDateIsLoading: false, }

        case actionsTypes.UPDATE_DEVICE_INSTALLATION_DATE_FAILED:
            return { ...state, installationDateIsLoading: false }

        case actionsTypes.GET_IMPULSE_RATE_HISTORY_REQUEST:
            return { ...state, isLoading: true }

        case actionsTypes.GET_IMPULSE_RATE_HISTORY_SUCCESS:
            return { ...state, isLoading: false, impulseRateHistory: action.payload }

        case actionsTypes.GET_IMPULSE_RATE_HISTORY_FAILED:
            return { ...state, isLoading: false }

        case actionsTypes.GET_FIRMWARE_HISTORY_REQUEST:
            return { ...state, isLoading: true }

        case actionsTypes.GET_FIRMWARE_HISTORY_SUCCESS:
            return { ...state, isLoading: false, firmwareHistory: action.payload }

        case actionsTypes.GET_FIRMWARE_HISTORY_FAILED:
            return { ...state, isLoading: false }

        case actionsTypes.GET_DEVICE_HISTORY_REQUEST:
            return { ...state, isLoading: true }

        case actionsTypes.GET_DEVICE_HISTORY_SUCCESS:
            return { ...state, isLoading: false, deviceHistory: action.payload }

        case actionsTypes.GET_DEVICE_HISTORY_FAILED:
            return { ...state, isLoading: false }

        case actionsTypes.CLEAR_ALL_SITES_DATA:
            return { ...state, ...initialState }

        default:
            return state
    }
}
